export default __webpack_public_path__ + "390aa266f451c1005f617c951b5ce0c3.svg";